<template lang="pug">
	.settings-end-card
		hr
		.content
			small.buttons-message.text-muted End card controls
			button.btn.btn-sm.btn-outline-secondary.edit(type="button" @click="toggleEndCard")
				i.fa.fa-eye
				| Toggle
</template>

<script>

	import Screen 					from './../../mixins/screen';

	export default {
		name: 'EndCardVersionSettings',
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Version Switched", "Settings Tab Changed:main"]
		},
		components: {

		},
		data() {

			return {
				showed: true
			};

		},
		methods: {

			collectData() {



			},

			toggleEndCard() {

				Broadcast.call("Send To iFrame", [{ToggleEndCard: true}]);

			}

		}

	}
</script>

<style lang="sass">

	.settings-end-card

		.content
			padding-top: 20px

		.buttons-message
			display: block
			padding-bottom: 10px

		button
			i
				margin-right: 5px
</style>
